import FetchService from "./fetch.service";
import { EXAMPLE_RELEASES, EXAMPLE_STATUS } from "./releaseExamples";

// TEMPORARY: show example release notes instead of calling the backend, to check the design locally.
// Nothing is saved while this is on. Set to false before committing.
const PREVIEW_WITH_EXAMPLES = false;

// Sent after release notes are marked as seen, so the sidebar can hide its dot straight away.
export const RELEASES_SEEN_EVENT = "releases:seen";

// Kept for the whole page load: the sidebar re-mounts on every navigation.
let statusRequest = null;

const requestJson = async (url, method = "GET", body = null) => {
  const fetchService = new FetchService();
  const options = { method, headers: {} };
  if (body) {
    options.headers["Content-Type"] = "application/json";
    options.body = JSON.stringify(body);
  }
  const response = await fetchService(url, options);
  const data = await response.json();
  if (!data.result) throw new Error(data.error);
  return data;
};

class ReleaseService {
  async getReleases() {
    if (PREVIEW_WITH_EXAMPLES) return EXAMPLE_RELEASES;

    const data = await requestJson("/releases/");
    return data.releases;
  }

  getStatus() {
    if (!statusRequest) {
      if (PREVIEW_WITH_EXAMPLES) {
        statusRequest = Promise.resolve(EXAMPLE_STATUS);
      } else {
        statusRequest = requestJson("/releases/status/").catch((error) => {
          statusRequest = null;
          throw error;
        });
      }
    }
    return statusRequest;
  }

  // Forget the remembered status on logout, so the next user in this tab doesn't see it.
  clearStatus() {
    statusRequest = null;
  }

  async markSeen() {
    if (!PREVIEW_WITH_EXAMPLES) {
      await requestJson("/releases/seen/", "POST");
    }

    // Everything is seen now, so reset the remembered status instead of asking the server again.
    if (statusRequest) {
      statusRequest = statusRequest.then((status) => ({ ...status, unseen_count: 0, show_catch_up: false }));
    }
    window.dispatchEvent(new Event(RELEASES_SEEN_EVENT));
  }

  async setEmailsEnabled(enabled) {
    if (!PREVIEW_WITH_EXAMPLES) {
      await requestJson("/releases/email-settings/", "POST", { enabled });
    }

    // Keep the remembered status in sync, so the switch shows the new value without reloading.
    if (statusRequest) {
      statusRequest = statusRequest.then((status) => ({ ...status, release_emails_enabled: enabled }));
    }
  }
}

const releaseService = new ReleaseService();
export default releaseService;
